/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `1` - Level 1 * `2` - Level 2 * `3` - Level 3
 */
export type LevelEnum = 1 | 2 | 3;

export const LevelEnum = {
    NUMBER_1: 1 as LevelEnum,
    NUMBER_2: 2 as LevelEnum,
    NUMBER_3: 3 as LevelEnum
};